 <template>
     <div class="advertiser-response-content">
         <div>{{ response }}</div>
         <div class="response-submission-date">
             <p>Submission Date<br>{{ formatDate(submissionTime) }}</p>
         </div>
     </div>
</template>

<script>
export default {
    name: 'review-response',
    props: {
        'response': {
            type: String,
            required: true
        },
        'submissionTime': {
            type: String,
            required: true
        },
    },
    methods: {
        formatDate: function (date) {
            return moment(date).format('MM/DD/YYYY hh:mm');
        },
    },
}
</script>
